module.exports = __webpack_public_path__ + "img/zxez_logo.d52ee4ec.png";